import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function useDevMode() {
  const navigate = useNavigate();
  const location = useLocation();

  // Check if dev mode is active
  const isDevModeActive = () => {
    const devModeData = localStorage.getItem('dev-mode-data');
    if (!devModeData) return false;
    
    try {
      const parsed = JSON.parse(devModeData);
      const now = Date.now();
      return parsed.enabled && now < parsed.expiresAt;
    } catch (e) {
      return false;
    }
  };

  // Add dev=true to URL if dev mode is active and parameter is missing
  useEffect(() => {
    if (isDevModeActive()) {
      const urlParams = new URLSearchParams(location.search);
      const hasDevParam = urlParams.get('dev') === 'true';
      
      if (!hasDevParam) {
        urlParams.set('dev', 'true');
        const newSearch = urlParams.toString();
        const newPath = `${location.pathname}?${newSearch}`;
        
        // Replace current URL without triggering navigation
        window.history.replaceState(null, '', newPath);
      }
    }
  }, [location]);

  return {
    isDevModeActive: isDevModeActive(),
    addDevParam: (path: string) => {
      if (isDevModeActive()) {
        const url = new URL(path, window.location.origin);
        url.searchParams.set('dev', 'true');
        return url.pathname + url.search;
      }
      return path;
    }
  };
}